export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarNavProfile.vue?vue&type=template&id=b46fde12&"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/SidebarNavProfile.vue?vue&type=template&id=b46fde12&
// module id = null
// module chunks = 